import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
// import { ListObject } from './common.classes';

export class DataAccess {

  constructor(private http: HttpClient, private apiUrl: string) {}

  getDataWithoutTimeout(methodWithQryParams: string, headerIfAny?: HttpHeaders) {
    return new Promise((resolve, reject) => {
      // assign url
      const getUrl = this.apiUrl + '/' + methodWithQryParams;

      // Headers if any assign else blank headers object
      let headers_object: HttpHeaders;
      if (headerIfAny === undefined || headerIfAny === null) {
        headers_object = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
      } else {
        headers_object = headerIfAny;
      }

      const httpOptions = {
        headers: headers_object
      };

      this.http.get(getUrl, httpOptions)
        .toPromise()
          .then (// call then instead of subscribe to form the promise chain.
            data => {
                resolve(data);
            },
            err => {
           
              reject(err);
            }
          )
          .catch(
            err => {
             
              reject(err);
            }
          );
    });
  }

  getData(methodWithQryParams: string, headerIfAny?: HttpHeaders, timeOutMS?: number) {
    return new Promise((resolve, reject) => {
      // assign url
      const getUrl = this.apiUrl + '/' + methodWithQryParams;
    
      // Headers if any assign else blank headers object
     
      let headers_object: HttpHeaders;
      if (headerIfAny === undefined || headerIfAny === null) {
        headers_object = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
      } else {
        headers_object = headerIfAny;
      }
     

      if (timeOutMS === undefined || timeOutMS === 0 || timeOutMS === null) {
        timeOutMS = 3000;
      }
     

      const httpOptions = {
        headers: headers_object
      };

      this.http.get(getUrl, httpOptions)
        .pipe(
          timeout(timeOutMS)
        )
        .toPromise()
          .then (// call then instead of subscribe to form the promise chain.
            data => {
                resolve(data);
            },
            err => {
              reject(err);
            }
          )
          .catch(
            err => {
              reject(err);
            }
          );
    });
  }

  postDataWithoutTimeout(methodWithQryParams: string, postBody: any, headerIfAny?: HttpHeaders) {
    return new Promise((resolve, reject) => {
      // assign url
      const postUrl = this.apiUrl + '/' + methodWithQryParams;

      // Headers if any assign else blank headers object
      let headers_object: HttpHeaders;
      if (headerIfAny === undefined || headerIfAny === null) {
        headers_object = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
      } else {
        headers_object = headerIfAny;
      }

      const httpOptions = {
        headers: headers_object
      };

      this.http.post(postUrl, postBody, httpOptions)
        .toPromise()
          .then (// call then instead of subscribe to form the promise chain.
            data => {

                resolve(data);
            },
            err => {
              reject(err);
            }
          )
          .catch(
            err => {
              reject(err);
            }
          );
    });
  }

  postData(methodWithQryParams: string, postBody: any, headerIfAny?: HttpHeaders, timeOutMS?: number) {
    return new Promise((resolve, reject) => {
      // assign url
      const postUrl = methodWithQryParams 
        ? `${this.apiUrl}/${methodWithQryParams}` 
        : this.apiUrl;

      // Headers if any assign else blank headers object
      let headers_object: HttpHeaders;
      if (headerIfAny === undefined || headerIfAny === null) {
        headers_object = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
      } else {
        headers_object = headerIfAny;
      }

      if (timeOutMS === undefined || timeOutMS === 0 || timeOutMS === null) {
        timeOutMS = 3000;
      }

      const httpOptions = {
        headers: headers_object
      };

      this.http.post(postUrl, postBody, httpOptions)
        .pipe(
          timeout(timeOutMS)
        )
        .toPromise()
          .then (// call then instead of subscribe to form the promise chain.
            data => {
                resolve(data);
            },
            err => {
              reject(err);
            }
          )
          .catch(
            err => {
              reject(err);
            }
          );
    });
  }

  getListData(methodWithQryParams: string, headerIfAny?: HttpHeaders, timeOutMS?: number) {
    return new Promise((resolve, reject) => {
      // assign url
      const getUrl = this.apiUrl + '/' + methodWithQryParams;
      // Headers if any assign else blank headers object
      let headers_object: HttpHeaders;
      if (headerIfAny === undefined || headerIfAny === null) {
        headers_object = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
      } else {
        headers_object = headerIfAny;
      }

      if (timeOutMS === undefined || timeOutMS === 0 || timeOutMS === null) {
        timeOutMS = 3000;
      }
      const httpOptions = {
        headers: headers_object
      };

      this.http.get(getUrl, httpOptions)
        .pipe(
          timeout(timeOutMS)
        )
        .toPromise()
          .then (// call then instead of subscribe to form the promise chain.
            data => {
            
                resolve(data);
            },
            err => {
              // const blankResult = new Array<ListObject>();
              // resolve(blankResult);
              // reject(err);
            }
          )
          .catch(
            err => {
              // const blankResult = new Array<ListObject>();
              // resolve(blankResult);
              // reject(err);
            }
          );
    });
  }

  getObserverDataWithoutTimeout(methodWithQryParams: string, headerIfAny?: HttpHeaders): Observable<any> {
      // assign url
      const getUrl = this.apiUrl + '/' + methodWithQryParams;

      // Headers if any assign else blank headers object
      let headers_object: HttpHeaders;
      if (headerIfAny === undefined || headerIfAny === null) {
        headers_object = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
      } else {
        headers_object = headerIfAny;
      }

      const httpOptions = {
        headers: headers_object
      };

      return this.http.get(getUrl, httpOptions);
  }

  getObserverData(methodWithQryParams: string, headerIfAny?: HttpHeaders, timeOutMS?: number): Observable<any> {
    // assign url
    const getUrl = this.apiUrl + '/' + methodWithQryParams;

    // Headers if any assign else blank headers object
    let headers_object: HttpHeaders;
    if (headerIfAny === undefined || headerIfAny === null) {
      headers_object = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
    } else {
      headers_object = headerIfAny;
    }

    if (timeOutMS === undefined || timeOutMS === 0 || timeOutMS === null) {
      timeOutMS = 3000;
    }

    const httpOptions = {
      headers: headers_object
    };

    return this.http.get(getUrl, httpOptions)
      .pipe(
        timeout(timeOutMS)
      );
  }
  putData(methodWithQryParams: string, putBody: any, headerIfAny?: HttpHeaders, timeOutMS?: number) {
    return new Promise((resolve, reject) => {
     
      const putUrl = methodWithQryParams 
        ? `${this.apiUrl}/${methodWithQryParams}` 
        : this.apiUrl;  
      
      let headers_object: HttpHeaders;
      if (headerIfAny === undefined || headerIfAny === null) {
        headers_object = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
      } else {
        headers_object = headerIfAny;
      }  
      
      if (timeOutMS === undefined || timeOutMS === 0 || timeOutMS === null) {
        timeOutMS = 3000;
      }
  
      const httpOptions = {
        headers: headers_object
      };
  
      this.http.put(putUrl, putBody, httpOptions)
        .pipe(
          timeout(timeOutMS)
        )
        .toPromise()
        .then(
          data => {
            resolve(data);
          },
          err => {
            reject(err);
          }
        )
        .catch(
          err => {
            reject(err);
          }
        );
    });
  }
  
  patchData(methodWithQryParams: string, patchBody: any, headerIfAny?: HttpHeaders, timeOutMS?: number) {
    return new Promise((resolve, reject) => {
  
      const patchUrl = methodWithQryParams 
        ? `${this.apiUrl}/${methodWithQryParams}` 
        : this.apiUrl;
  
      let headers_object: HttpHeaders;
      if (headerIfAny === undefined || headerIfAny === null) {
        headers_object = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
      } else {
        headers_object = headerIfAny;
      }
  
      if (timeOutMS === undefined || timeOutMS === 0 || timeOutMS === null) {
        timeOutMS = 3000;
      }
  
      const httpOptions = {
        headers: headers_object
      };
  
      this.http.patch(patchUrl, patchBody, httpOptions)
        .pipe(
          timeout(timeOutMS)
        )
        .toPromise()
          .then(
            data => resolve(data),
            err => reject(err)
          )
          .catch(
            err => reject(err)
          );
    });
  } 
}
